import Button from "Components/button";
import { TextWidget } from "Components/optionForm";
import ProgressOverlay from "Components/progressOverlay";
import Scrollbars from "Components/scrollbars";
import WelcomePanel from "Components/welcomePanel";
import classNames from "classnames";
import { CheckBox } from "devextreme-react/check-box";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import reject from "lodash/reject";
import trim from "lodash/trim";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import locale from "./panel.locale";
const handleStopPropagation = (evt) => {
    evt.stopPropagation();
};
export default function Panel(props) {
    var _a;
    const [name, setName] = useState("");
    const [selectedSummaryReportIds, setSelectedSummaryReportIds] = useState([]);
    const [inProgress, setInProgress] = useState(false);
    useEffect(() => {
        props.data.DocumentId &&
            props.projectId &&
            props.onInitialized &&
            props.onInitialized(props.data.DocumentId, props.projectId);
    }, []);
    const canAdd = useMemo(() => !isEmpty(trim(name)) && !isEmpty(selectedSummaryReportIds), [name, selectedSummaryReportIds]);
    const handleAdd = useCallback(async () => {
        if (!canAdd || !props.onAdd)
            return;
        setInProgress(true);
        const value = await props.getValue(props.data.SummaryReportObjectType);
        if (!value) {
            setInProgress(false);
            return;
        }
        props.onAdd({
            ...props.data,
            Name: name,
            Value: value
        }, selectedSummaryReportIds, () => {
            props.onHide && props.onHide();
            setInProgress(false);
        }, () => {
            setInProgress(false);
        });
    }, [props.onAdd, canAdd, props.data, name, selectedSummaryReportIds, props.getValue]);
    const selectAll = useMemo(() => props.summaryReports ? (React.createElement("div", { className: "grid-cols-auto-1fr pb-0_5 clickable", onClick: () => {
            var _a;
            setSelectedSummaryReportIds((selectedSummaryReportIds === null || selectedSummaryReportIds === void 0 ? void 0 : selectedSummaryReportIds.length) !== ((_a = props.summaryReports) === null || _a === void 0 ? void 0 : _a.length)
                ? map(props.summaryReports, "Id")
                : []);
        } },
        React.createElement(CheckBox, { activeStateEnabled: false, value: isEmpty(selectedSummaryReportIds)
                ? false
                : (selectedSummaryReportIds === null || selectedSummaryReportIds === void 0 ? void 0 : selectedSummaryReportIds.length) === props.summaryReports.length
                    ? true
                    : undefined }),
        React.createElement("div", { className: "ml-0_75 text-muted" }, locale.SELECT_ALL))) : null, [props.summaryReports, selectedSummaryReportIds]);
    const mainFormStyle = useMemo(() => ({
        gridTemplateRows: `repeat(${3 + (props.customForm ? 1 : 0)}, auto) 1fr`
    }), [Boolean(props.customForm)]);
    return (React.createElement(ProgressOverlay, { show: props.inProgress || inProgress, ignoreParentOverlayInProgress: true, className: props.className },
        React.createElement("div", { className: "grid-rows-1fr-auto", onSelect: handleStopPropagation },
            React.createElement("div", { style: mainFormStyle, className: classNames("d-grid pt-0_25 pl-0_5 pr-0_5 overflow-hidden", props.mainFormClassName) },
                React.createElement(TextWidget, { value: name, onChange: setName, label: locale.NAME, labelMode: "floating" }),
                props.customForm,
                React.createElement("div", { className: "font-smallest text-gray-500 mb-1 mt-1_5" }, locale.SUMMARY_REPORTS),
                !props.summaryReports && React.createElement("div", null),
                ((_a = props.summaryReports) === null || _a === void 0 ? void 0 : _a.length) === 0 ? (React.createElement(WelcomePanel, { messageClassName: "font-base", showIcon: false, message: locale.NO_AVAILABLE_SUMMARY_REPORTS })) : (props.summaryReports && (React.createElement("div", { className: "grid-rows-auto-1fr overflow-hidden" },
                    selectAll,
                    React.createElement("div", { className: "overflow-hidden" },
                        React.createElement(Scrollbars, null,
                            React.createElement("div", { className: "pl-0_75" }, map(props.summaryReports, item => (React.createElement("div", { className: "grid-cols-auto-1fr pt-0_5 pb-0_5 clickable", key: item.Id, onClick: () => {
                                    setSelectedSummaryReportIds(prev => !includes(selectedSummaryReportIds, item.Id)
                                        ? [...prev, item.Id]
                                        : reject(prev, p => p === item.Id));
                                } },
                                React.createElement(CheckBox, { activeStateEnabled: false, value: includes(selectedSummaryReportIds, item.Id) }),
                                React.createElement("div", { className: "ml-0_75 text-overflow-ellipsis", title: item.Name }, item.Name))))))))))),
            React.createElement("div", { className: "pt-1 d-flex justify-content-flex-end pb-0_5 pl-0_5 pr-0_5" },
                React.createElement(Button, { onClick: props.onHide, height: 36 }, locale.CANCEL),
                React.createElement(Button, { height: 36, disabled: !canAdd, onClick: handleAdd, className: "btn-primary ml-1" }, locale.ADD)))));
}
